module.exports = __webpack_public_path__ + "static/media/ico-edit.b75688ba.svg";